import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root',
})
export class DeliveryPreferenceService {
  constructor(private ws: PostmethodService) {}

  getDeliveryPreference(): Observable<any> {
    const requestPayload = { flag: 'list' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'deliveryPreferenceMaster'
    );
  }

  createDeliveryPreference(data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'create' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'deliveryPreferenceMaster'
    );
  }

  updateDeliveryPreference(id: number, data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'update', id };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'deliveryPreferenceMaster'
    );
  }

}
